<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('statuses')"
      :columns="columns"
      :column_search="true"
      resource_url="/staff/status/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <status-modal ref="status_modal" @success="refresh" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_date,
} from "@/utils";
import StatusModal from "./status_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "StaffStatusDatatable",
  components: { GenericTable, StatusModal },
  props: {},
  data() {
    let v = this;
    return {
      columns: [
        // {
        //   title: v.$t("date"),
        //   searchable: false,
        //   // width: "25%",
        //   data: (row) => {
        //     return format_date(row.create_date);
        //   },
        // },
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("code"),
          searchable: false,
          // width: "55%",
          data: (row) => {
            // return truncate(JSON.stringify(row), { length: 65 });
            return row.code || "";
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.status_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete status?"),
                    v,
                    () => {
                      del("/staff/status", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.status_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
